import { render } from "./BaseHeading.vue?vue&type=template&id=952d8d56"
import script from "./BaseHeading.vue?vue&type=script&lang=js"
export * from "./BaseHeading.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__